import { Component, inject } from '@angular/core';
import { injectDispatch } from '@ngrx/signals/events';
import { Divider } from 'primeng/divider';
import {
  OffshorePositionAndWeatherFormStore,
  offshorePositionAndWeatherEvents,
  OffshoreReportStore,
} from '@navstation-portal/reporting/data-access/offshore-report';
import { DynamicFormComponent } from '../shared/dynamic-form/dynamic-form.component';
import { WindComponent } from './sections/wind/wind.component';
import { SpeedAndDistanceComponent } from './sections/speed-and-distance/speed-and-distance.component';
import { CurrentsAndSeaWaterComponent } from './sections/currents-and-sea-water/currents-and-sea-water.component';
import { ObservationComponent } from './sections/observation/observation.component';
import { ShipPositionComponent } from './sections/ship-position/ship-position.component';
import { WeatherEffectComponent } from './sections/weather-effect/weather-effect.component';
import { PositionAndLogisticsComponent } from './sections/position-and-logistics/position-and-logistics.component';

@Component({
  selector: 're-offshore-weather',
  standalone: true,
  templateUrl: './offshore-weather.component.html',
  imports: [
    WindComponent,
    SpeedAndDistanceComponent,
    CurrentsAndSeaWaterComponent,
    ObservationComponent,
    ShipPositionComponent,
    WeatherEffectComponent,
    DynamicFormComponent,
    PositionAndLogisticsComponent,
    Divider,
  ],
})
export class OffshoreWeatherComponent {
  weatherStore = inject(OffshorePositionAndWeatherFormStore);
  events = injectDispatch(offshorePositionAndWeatherEvents);
  offshoreReportStore = inject(OffshoreReportStore);
}
